import React, { useCallback } from 'react';

import styled from 'styled-components';

import { useDropzone } from 'react-dropzone';
import { Typography, Grid } from '@material-ui/core';
import { Icon } from '@mdi/react';
import { mdiCloudUpload } from '@mdi/js';

const getColor = props => {
  if (props.isDragAccept) {
    return '#00e676';
  }
  if (props.isDragReject) {
    return '#ff1744';
  }
  if (props.isFocused) {
    return '#2196f3';
  }
  return '#a4a4a4';
};

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px dashed;
  padding: 20px;
  border-radius: 4px;
  border-color: ${props => getColor(props)};
  border-style: dashed;
  background-color: #fafafa;
  color: #2f4858;
  outline: none;
  transition: border 0.24s ease-in-out;
  cursor: pointer;
`;

export const RonadDropzone = props => {
  const onDrop = useCallback((acceptedFiles) => {
    return props.onDropped(acceptedFiles[0]);
  })
  const { acceptedFiles, getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({ onDrop });



  return (
    <div className="container">
      <Container {...getRootProps({ isFocused, isDragAccept, isDragReject })}>
        <Grid container justifyContent='center' spacing={1}>
          <input id="file"
            type="file"
            name="file"
            ref={props.register}
            {...getInputProps()} />
          <Grid item>
            <Icon path={mdiCloudUpload} size={1} />
          </Grid>
          <Grid item>
            <Typography className="primary">انتخاب فایل</Typography>
          </Grid>
        </Grid>

      </Container>
    </div>
  );
};
